export default __webpack_public_path__ + "static/media/suklogo.a18a326c0f838154863b180deeee461e.webp";